import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { Tab, Tabs } from "@mui/material";
import PageWrapper from "@components/Home/PageWrapper";
import MyAccount from '@components/MyAccount/MyAccount';
import Billing from '@components/Billing/Billing';

enum SettingsTab {
  MyAccount = "MyAccount",
  Billing = "Billing",
}

const Settings: FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<SettingsTab>(SettingsTab.MyAccount);

  const location = useLocation();

  useEffect(() => {
    let tab = SettingsTab.MyAccount;
    if (location?.pathname?.includes("billing")) {
      tab = SettingsTab.Billing;
    }
    setSelectedTab(tab);
  }, [location]);

  return (
    <PageWrapper>
      <Tabs value={selectedTab} sx={{ marginBottom: "32px" }}>
        <Tab
          label={t("myAccount.title")}
          value={SettingsTab.MyAccount}
          component={Link}
          to="myAccount"
        />
        <Tab
          label={t("billing.title")}
          value={SettingsTab.Billing}
          component={Link}
          to="billing"
        />
      </Tabs>

      <Routes>
        <Route path="" element={<MyAccount />} />
        <Route path="billing" element={<Billing />} />
        <Route path="*" element={<MyAccount />} />
      </Routes>
    </PageWrapper>
  );
};

export default Settings;
